//NavButton.jsx

import React from "react";
import Button from "@mui/material/Button";
import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'primary',
})(({ theme, primary }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(1),
  textTransform: "none",
  transition: "all 0.2s ease-in-out",
  boxShadow: theme.shadows[1],
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 600,
  borderRadius: theme.shape.borderRadius * 1.5,
  minWidth: 100,
  height: 36,
  padding: theme.spacing(0, 2),
  "& svg": {
    fontSize: "1.1rem",
  },
  ...(primary
    ? {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
          transform: "scale(1.03)",
          boxShadow: theme.shadows[3],
        },
        "&.Mui-disabled": {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          opacity: 0.5,
          cursor: "not-allowed",
        },
      }
    : {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.primary,
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
          transform: "scale(1.02)",
          boxShadow: theme.shadows[2],
        },
        "&.Mui-disabled": {
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.disabled,
          border: `1px solid ${theme.palette.divider}`,
          opacity: 0.5,
          cursor: "not-allowed",
        },
      }),
}));

  

const NavButton = ({
  icon,
  label,
  primary = false,
  onClick,
  disabled = false,
  tooltip = null,


}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const button = (
    <StyledButton
      primary={primary ? 1 : 0}
      onClick={onClick}
      disabled={disabled}
      // DAS-2714: stable machine-readable handle derived from the label, so the
      // testing-ticket auditor's `verify: ui click` markers can target nav
      // buttons (e.g. "Portfolio" -> nav-portfolio). Text labels are not CSS-
      // selectable; without this, every modal-gated UI ticket is unauditable.
      data-testid={`nav-${String(label).toLowerCase().replace(/\s+/g, "-")}`}
    >
      {icon}
      {!isSmallScreen && <Box component="span">{label}</Box>}
    </StyledButton>
  );

  if (tooltip && !disabled) {
    return (
      <Tooltip title={tooltip} arrow enterDelay={1500} placement="bottom">
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};

export default NavButton;
